import React, { Component } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label
} from "reactstrap";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import handleValidation from "../../Validation";
import "./style.css";
import Calendly from "./Calendly";

class JobGuarantee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      first_name: "",
      last_name: ""
    };

    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }
  splitString = () => {
    debugger
    let fullName = this.refs.first_name.value;
    var firstSpaceIndex = fullName.indexOf(" ");
    var firstName = fullName.substr(0, firstSpaceIndex);
    var lastName = fullName.substr(firstSpaceIndex + 1);
    this.setState({
      first_name: firstName, last_name: lastName
    })
  }

  submitDetails = (event) => {
    debugger
    let formData = {
      first_name: this.refs.first_name.value,
      //last_name: this.refs.last_name.value,
      email: this.refs.email.value,
      contact: this.refs.phone.value
    };
    let errors = handleValidation(formData);
    this.setState({ errors: errors });

    if (errors["valid"] == true) {
      document.getElementById("scheduleCall").action = "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
      document.getElementById("scheduleCall").method = "POST"
    } else {
      this.setState({ errorsdiv: true })
      event.preventDefault();
    }
  }

  render() {
    return (
      <div className="section-padding job-guarantee-section">
        <Container>
          <Row>
            <Col sm={{ size: 6 }}>
              <h1 className="left-align mt-5 mb-5">
                What's More Than A Job Guarantee
              </h1>{" "}
            </Col>
          </Row>
          <Row>
           
            <Col  sm={{ size: 6 }}>
              <p className="job-guarantee-description">
                At Lighthouse, our career services team works with you to get
                hired, and our mentors work with you to stay inspired
                in your entire career journey.
                <br />
                <br />
                We do not want you to feel stuck after you have secured a job.
                With technology changing every few years, you will be developing
                new and valuable skills as the industry evolves. We want to help
                you keep your curiosity and spark, so that you can
                continue to stay relevant, forever. Learn more about how we will
                work with you through your career and keep adding emerging
                skills. <br />
                <br />
                <span className="start-now">start now</span>
              </p>
              <Button className="courses-button " onClick={this.toggle}>
                {this.props.buttonLabel}Schedule A Call
              </Button>{" "}
            </Col>
          </Row>
        </Container>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
        >
          <Calendly />Î
        
        </Modal>
      </div>
    );
  }
}

export default JobGuarantee;
